import {ValueObject} from '@s-ui/domain'

import {FilterIdSearchValueObject} from './FilterIdSearchValueObject.js'

export class FilterRegionIdSearchValueObject extends ValueObject {
  #regionId

  constructor({regionId}) {
    super()
    this.#regionId = regionId
  }

  static create({regionId}) {
    return new FilterRegionIdSearchValueObject({regionId: FilterIdSearchValueObject.create(regionId)})
  }

  static createWithDefaultValue({config, regionId}) {
    const {DEFAULT_REGION_ID_SEARCH} = config.get('searchFilters')

    return new FilterRegionIdSearchValueObject({
      regionId: FilterIdSearchValueObject.create({id: regionId ?? DEFAULT_REGION_ID_SEARCH})
    })
  }

  get isEmpty() {
    return this.#regionId.isEmpty
  }

  get value() {
    return this.#regionId.value
  }

  toJSON() {
    return {
      regionId: this.#regionId.toJSON()
    }
  }
}
